import { ReactComponent as RefuseIcon } from '../../assets/icons/refuse.svg'
import IconedButton, { IconedButtonProps } from './IconedButton/IconedButton'

const RefuseButton = (props: Omit<IconedButtonProps, 'Icon'>) => {
  return <IconedButton Icon={RefuseIcon} {...props} />
}

export default RefuseButton
